/** Marqueur session : le prochain chargement doit éviter les saves de réparation post-reset. */
export const ASCENSION_HARD_RELOAD_KEY = 'poke-idle-ascension-hard-reload'

export function markAscensionHardReloadPending(): void {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.setItem(ASCENSION_HARD_RELOAD_KEY, String(Date.now()))
    }
  } catch {
    // ignore
  }
}

export function consumeAscensionHardReloadPending(): boolean {
  try {
    if (typeof sessionStorage === 'undefined') return false
    const raw = sessionStorage.getItem(ASCENSION_HARD_RELOAD_KEY)
    if (!raw) return false
    sessionStorage.removeItem(ASCENSION_HARD_RELOAD_KEY)
    return true
  } catch {
    return false
  }
}

export function redirectHomeAfterAscension(): void {
  if (typeof window === 'undefined') return
  window.location.replace('/')
}
